export const goodConditionImage = "/assets/jpg/good.jpg";
export const laptopImage = "/assets/jpg/laptop.jpg";
export const officeworkImage = "/assets/jpg/officework.jpg";
export const happyworkImage = "/assets/jpg/happywork.jpg";
export const laptopworkImage = "/assets/jpg/worklaptop.jpg";